var map = {
	"./Avatars.png": "b83c",
	"./Help_Center.png": "1aab",
	"./Help_center_blue.png": "8845",
	"./Location.png": "db60",
	"./Location_blue.png": "d8e5",
	"./Log_Sheet.png": "0834",
	"./Log_Sheet_blue.png": "86cf",
	"./Logo.png": "5684",
	"./Persons.png": "f595",
	"./Persons_blue.png": "5d52",
	"./Receiver.png": "2a50",
	"./Receiver_blue.png": "975e",
	"./Refresh.png": "fb41",
	"./Refresh_blue.png": "e0b9",
	"./Search.png": "4bcf",
	"./Search_blue.png": "d50e",
	"./Vector.png": "a35f",
	"./Virus.png": "2fb3",
	"./Virus_blue.png": "8096",
	"./logo-icon.png": "4c54",
	"./tag.png": "6a22",
	"./tag_blue.png": "4adc",
	"./wifi.png": "1466",
	"./wifi_blue.png": "9562"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";